import { Icon } from "./Icon.tsx";

/** "Update from CSVs" icon for icon-only buttons — an upload arrow (CSVs going back INTO the project), same style as DownloadIcon.tsx (which is the reverse direction). */
export function RefreshFromFilesIcon() {
  return (
    <Icon>
      <path d="M12 15V3" />
      <path d="M7 8l5-5 5 5" />
      <path d="M4 19h16" />
    </Icon>
  );
}
